import { render } from "./BannersTab.vue?vue&type=template&id=799ff290"
import script from "./BannersTab.vue?vue&type=script&lang=js"
export * from "./BannersTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__